import { render } from "./terraces-section.vue?vue&type=template&id=9c6c8866"
import script from "./terraces-section.vue?vue&type=script&lang=js"
export * from "./terraces-section.vue?vue&type=script&lang=js"

import "./terraces-section.vue?vue&type=style&index=0&id=9c6c8866&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__